import script from "./CryptoIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptoIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CryptoIcon.vue?vue&type=style&index=0&id=851fe0ae&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-851fe0ae"]])

export default __exports__